import { Component, OnInit,Input } from '@angular/core';
import { FormGroup,FormControl,FormBuilder,Validators } from '@angular/forms';
import { JobService } from '../../../../services/job/job.service';
import {Router,ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-overview-schedule-inspection',
  templateUrl: './overview-schedule-inspection.component.html',
  styleUrls: ['./overview-schedule-inspection.component.scss']
})
export class OverviewScheduleInspectionComponent implements OnInit {
  @Input() job;
  // jobDetials=[];
  newInspection = this.fb.group({
    job_sub_type: [''],
    reinspection_options_client:true,
    reinspection_options_parties:true,
    reinspection_options_inspector:true,
    reinspection_options_info:true,
    reinspection_options_diagram:true,
    reinspection_note:['']
  });
  is_loading:boolean;
  constructor(
    private fb: FormBuilder,
    public jobService:JobService,
    private  _router : Router,
     ) { }

  ngOnInit() {
    // this.jobDetials = [...this.job];
  }
  onSubmit(){
    if(this.is_new_parent){
      let msg = "Create a new parent Original for this property?\n\n"
        + "This creates a new parent (not a child) with no findings copied. It starts a separate inspection "
        + "family, so it will not roll up together with the current inspection in reporting.";
      if(this.existing_originals > 0){
        msg += "\n\nThis property already has "+this.existing_originals+" other parent inspection(s).";
      }
      if(!confirm(msg)){
        return;
      }
    }
    this.is_loading=true;
    // console.log("newInspection",this.newInspection.value)
    const jobDetials = {"new_inspection":this.newInspection.value,"job":this.job};
    this.jobService.newInspection(jobDetials).subscribe(
      data=>{
        this.is_loading=false;
        // console.log("ready",)
        if(this.newInspection.value.reinspection_options_client && this.newInspection.value.reinspection_options_parties &&  this.newInspection.value.reinspection_options_inspector){
          this._router.navigate(['inspections-schedule/', data.data]);
        }else{
          this._router.navigate(['inspections-completed-sheet/', data.data]);
        }
    })
  }
  import_option = false;
  is_new_parent = false;
  existing_originals = 0;
  inspectionType(){
    if(this.newInspection.value.job_sub_type !=''){
      this.import_option = true;
      // console.log(this.newInspection.value.job_sub_type)
    }else{
      this.import_option = false;
    }
    this.is_new_parent = this.newInspection.value.job_sub_type == 'NewParentOriginal';
    if(this.is_new_parent){
      // count OTHER root inspections on this property; the current job is itself always a root
      this.jobService.existingOriginals(this.job.property_id, this.job.job_id).subscribe(
        data=>{
          this.existing_originals = data.data.count;
      })
    }else{
      this.existing_originals = 0;
    }
  }

}
